export const CONST = {
    ADD_TO_QUOTE_BTN: "add_to_qoute_btn",
    HIDE_PRICE: "hide_price",
    QUOTE_BUTTON: "gf_quote_button",
    REQUEST_A_QUOTE_PAGE: "request_a_quote_page",
    PRODUCT_LIST_PAGE: "gf_quote_product_list_page",
    PRODUCT_COLLECTION_HREF: "gf_quote_product_collection_href",
};
